"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useEffect } from 'react';
import { textAreaRecipe, textAreaWrapperRecipe } from './recipe.mjs';

const CssPropTextareaMaxHeight = "--uikit-textarea-max-height";
const Textarea = forwardRef(({ autoHeight, ...props }, ref) => {
  if (autoHeight) {
    return /* @__PURE__ */ jsx(TextareaWithAutoHeight, { ref, ...props });
  }
  return /* @__PURE__ */ jsx(GenericTextarea, { ref, ...props });
});
Textarea.displayName = "Textarea";
const { textarea: textAreaSlot } = textAreaRecipe();
const { wrapper: textAreaWrapperSlot } = textAreaWrapperRecipe();
const GenericTextarea = forwardRef(
  ({ className, children, ...props }, ref) => {
    return /* @__PURE__ */ jsx("textarea", { ref, className: textAreaSlot({ className }), ...props, children });
  }
);
const TextareaWithAutoHeight = forwardRef(
  ({ maxHeight = "auto", ...props }, ref) => {
    const refWrapper = useRef(null);
    const handleOnInput = (e) => {
      const wrapper = refWrapper.current;
      if (wrapper) {
        wrapper.dataset.replicatedValue = e.target.value;
      }
    };
    useEffect(() => {
      const maxHeightValue = typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight;
      refWrapper?.current?.style.setProperty(CssPropTextareaMaxHeight, `${maxHeightValue}`);
    }, [maxHeight]);
    return /* @__PURE__ */ jsx("div", { ref: refWrapper, className: textAreaWrapperSlot(), children: /* @__PURE__ */ jsx(GenericTextarea, { ref, onInput: handleOnInput, ...props }) });
  }
);

export { Textarea };
